import { render, staticRenderFns } from "./CoursesAndSeminars.vue?vue&type=template&id=1311a057&scoped=true&"
import script from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
export * from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
import style0 from "./CoursesAndSeminars.vue?vue&type=style&index=0&id=1311a057&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311a057",
  null
  
)

export default component.exports